import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {LanguageService} from "./core/services/language.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'signature-public';

    constructor(
        private router: Router,
        private lang: LanguageService
    ) {
        this.lang.autoResolveLanguage();
    }

    ngOnInit() {
        // this.router.navigate(['audit']).then();
    }
}
